import styled, { css } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius2};

  ${props =>
    typeof props.onClick === 'function' &&
    css`
      cursor: pointer;
      &:hover {
        background-color: ${props.theme.colors.background.secondary};
      }
    `}
`

export const SideContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const ProductImage = styled.img`
  height: 72px;
  aspect-ratio: 1/1;
  object-fit: contain;
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const SkuAndVariantContainer = styled.div`
  display: grid;
  gap: ${props => props.theme.spacing.sp8};
  padding-right: ${props => props.theme.spacing.sp16};

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const Total = styled(Text)`
  min-width: ${props => props.theme.size.XXL};
  text-align: right;
`

export const NavigationContainer = styled.div`
  min-width: ${props => props.theme.size.S};

  svg {
    display: none;
  }

  ${Container}:hover & {
    svg {
      display: block;
    }
  }
`

export const ChipWrapper = styled.div`
  display: flex;
`
